import { render, staticRenderFns } from "./marshall_starter_order.vue?vue&type=template&id=66dfe88a&scoped=true"
import script from "./marshall_starter_order.vue?vue&type=script&lang=js"
export * from "./marshall_starter_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfe88a",
  null
  
)

export default component.exports